import api from './apiClient';
import { emitAuthTokensEvent } from './apiClient';
import { AuthTokens, LoginCredentials, RegisterData, User, VeterinarianRegistrationFromControl } from '../types';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthTokens> => {
    const response = await api.post('/auth/login', credentials);
    const tokens = response.data;
    localStorage.setItem('access_token', tokens.access_token);
    localStorage.setItem('refresh_token', tokens.refresh_token);
    emitAuthTokensEvent(tokens.access_token, tokens.refresh_token);
    return tokens;
  },

  reactivateAccount: async (credentials: LoginCredentials): Promise<AuthTokens> => {
    const response = await api.post('/auth/reactivate', credentials);
    const tokens = response.data;
    localStorage.setItem('access_token', tokens.access_token);
    localStorage.setItem('refresh_token', tokens.refresh_token);
    emitAuthTokensEvent(tokens.access_token, tokens.refresh_token);
    return tokens;
  },

  register: async (userData: RegisterData): Promise<User> => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    emitAuthTokensEvent(null, null);
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  registerVeterinarianFromControl: async (
    registrationData: VeterinarianRegistrationFromControl
  ): Promise<{ user: User; token: AuthTokens; message: string }> => {
    const response = await api.post('/auth/register-veterinarian-from-control', registrationData);
    const tokens = response.data.token;
    localStorage.setItem('access_token', tokens.access_token);
    localStorage.setItem('refresh_token', tokens.refresh_token);
    emitAuthTokensEvent(tokens.access_token, tokens.refresh_token);
    return response.data;
  },

  forgotPassword: async (email: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  resetPassword: async (token: string, newPassword: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/reset-password', {
      token,
      new_password: newPassword,
    });
    return response.data;
  },

  sendVerificationCode: async (email: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/send-verification-code', { email });
    return response.data;
  },

  getEmailFromVerificationToken: async (token: string): Promise<{ email: string }> => {
    const response = await api.get('/auth/verify-email-token', { params: { token } });
    return response.data;
  },
  verifyEmail: async (email: string, code: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/verify-email', { email, code });
    return response.data;
  },

  requestAccountReactivation: async (email: string): Promise<{ message: string }> => {
    const response = await api.post('/auth/request-reactivation', { email });
    return response.data;
  },
};



